"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createConnect_1 = require("./createConnect");
var _a = createConnect_1.default({
    field: 'suggestions',
    handlers: {
        getSuggestionProps: function (_a) {
            var update = _a.update, analytics = _a.analytics, meta = _a.meta, suggestions = _a.suggestions;
            return function (index, widgetKey) {
                if (widgetKey === void 0) { widgetKey = ''; }
                var suggestion = suggestions.get(index);
                var value = suggestion.get('value');
                return {
                    key: value,
                    onClick: function (e) {
                        if (e)
                            e.preventDefault();
                        update('q', value);
                        analytics.sendEvent('click-suggestion', {
                            suggestion: value,
                            rid: meta.get('rid'),
                        });
                        window.findify.emit('autocompleteFocusLost', widgetKey);
                        window.findify.emit('search', widgetKey, suggestion);
                    }
                };
            };
        }
    }
}), hook = _a[0], connect = _a[1];
exports.hook = hook;
exports.connect = connect;
//# sourceMappingURL=connectSuggestions.js.map